// extracted by css-extract-rspack-plugin
export default {"selectorButton":"ScopePicker-module__selectorButton__FVBNx","avatarLeadingVisual":"ScopePicker-module__avatarLeadingVisual__cMcSe","itemMeta":"ScopePicker-module__itemMeta__NW9Dp"};